import { MultipleChoicesType } from '../MultipleChoicesWidget.types';
import { HorizontalMultipleChoices } from './HorizontalMultipleChoices';

/**
 * Map of multiple choices type to the corresponding component
 * This is single type for now, but can plan to extend it in the future
 */
export const MULTIPLE_CHOICES_TYPE_MAP = {
  [MultipleChoicesType.Horizontal]: HorizontalMultipleChoices,
};
